/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HealthDumpControllerService {

    /**
     * @param name
     * @returns string OK
     * @throws ApiError
     */
    public static listHealthDumpFiles(
        name: string,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health-dumps/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns binary OK
     * @throws ApiError
     */
    public static executeHealthDump(
        name: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health-dumps/{name}/execute',
            path: {
                'name': name,
            },
            errors: {
                400: `Invalid node name`,
                401: `Unauthorized`,
                404: `Node not found`,
                500: `Internal server error while creating or writing health dump file`,
            },
        });
    }

    /**
     * @param name
     * @param filePath
     * @returns binary OK
     * @throws ApiError
     */
    public static getHealthDumpFile(
        name: string,
        filePath: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health-dumps/{name}/download',
            path: {
                'name': name,
            },
            query: {
                'filePath': filePath,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
